// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2546":"99242048","6264":"99242048","6925":"74b56c4f","7338":"5ec4d9d5","7488":"03addb7f","9306":"53f3dfb4"}[chunkId] + ".chunk.css";
};